import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { $getRoot } from 'lexical';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useEditorProps } from '../../core/context/EditorPropsContext';
import { useFeatureConfig } from '../../core/context/FeaturesContext';
import { lineBoxClasses } from '../../ui/styles';

/**
 * `count/max` beside the content; turns red once the limit is reached.
 * - Same one-line-high box as the text (`lineBoxClasses`), so it centres on one line and sits at the bottom on more.
 */
export const CharacterCounter = () => {
  const [editor] = useLexicalComposerContext();
  const max = useFeatureConfig('characterLimit')?.max;
  const { size = 'm' } = useEditorProps();
  const { t } = useTranslation('common');
  const [count, setCount] = useState(() => editor.getEditorState().read(() => $getRoot().getTextContentSize()));

  useEffect(() => editor.registerTextContentListener((text) => setCount(text.length)), [editor]);

  if (!max) return null;

  return (
    <span
      className={`text-pbk-12 flex shrink-0 items-center self-end pr-2 tabular-nums select-none ${lineBoxClasses[size]} ${count >= max ? 'text-semantic-error' : 'text-text-2'}`}
      aria-label={t('editor.character-count', { count, max })}
    >
      {count}/{max}
    </span>
  );
};
